// 联系方式
<template>
  <div>
    <Logo></Logo>
	<!-- 页头 -->
	<!-- <Header></Header> -->
    <div><img :src="image" class="bg"></div>
    <div class="kong">
        <div class="descriptions" v-for="(list,i) in lists">
    		<el-descriptions direction="horizontal" v-bind:title=list.one :column='1' v-bind:colon=false>
    		    <el-descriptions-item label="" class="img" >
                <el-card shadow="always" class="card" style="width:37.5rem;margin-left:3.125rem;">
                <div class="address">地址</div>
                <div class="address_list">{{list.six}}</div>
                </el-card>
    		    	<el-image :src="require('../../assets/img/address.png')"></el-image>
                    
    		    </el-descriptions-item>
    		    <el-descriptions-item v-if="list.three !== null" class="description">
                    <template :slot="label">
                        <div style="display:flex;align-items: center">
                            <el-image style="width:1.75rem;height:2.1875rem" :src="require('@/assets/img/phone.png')"></el-image>
                            <span style="color:#666666;font-size:1.5rem;margin-left:2.1875rem;width:6rem;">总机：</span>
                            <span>{{list.three}}</span>
                        </div>
                    </template>
                </el-descriptions-item>
                <el-descriptions-item v-if="list.seven !== null" class="description">
                    <template :slot="label">
                        <div style="display:flex;align-items: center">
                            <el-image style="width:1.75rem;height:2.1875rem" :src="require('@/assets/img/phone.png')"></el-image>
                            <span style="color:#666666;font-size:1.5rem;margin-left:2.1875rem;width:6rem;">电话：</span>
                            <span>{{list.seven}}</span>
                        </div>
                    </template>
                </el-descriptions-item>
    		    <el-descriptions-item v-if="list.four !== null"  class="description">
                    <template :slot="label">
                        <div style="display:flex;align-items: center">
                            <span style="color:#666666;font-size:1.5rem;margin-left:3.8875rem;width:6rem;">传真：</span>
                            <span>{{list.four}}</span>
                        </div>
                    </template>
                </el-descriptions-item>
    		    <el-descriptions-item class="description">
                        <template :slot="label">
                        <div style="display:flex;align-items: center">
                            <span style="color:#666666;font-size:1.5rem;margin-left:3.8875rem;width:6rem;">邮箱：</span>
                            <span>{{list.five}}</span>
                        </div>
                    </template>
                </el-descriptions-item>
    			<el-descriptions-item  class="description">
                    <template :slot="label">
                        <div style="display:flex;align-items: center">
                            <el-image style="width:1.75rem;height:2.1875rem" :src="require('@/assets/img/position.png')"></el-image>
                            <span style="color:#666666;font-size:1.5rem;margin-left:2.1875rem;width:7rem; word-break: keep-all;">地址：</span>
                            <span>{{list.six}}</span>
                        </div>
                    </template>
                </el-descriptions-item>
    		</el-descriptions>
    	</div>
    </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
import Header from '../../common/FirstHeader.vue'
import api from '@/utils/api'
import Tabbar from '../Index/Index_components/Tabbar.vue'
import Logo from "../Index/Index_components/logo.vue"
export default {
  name: 'contactInformation',
  components: {
    // Header,
    Tabbar,
    Logo,
  },
  created () {
    if (window.localStorage.getItem('contactImage')) {
      var image1 = JSON.parse(window.localStorage.getItem('contactImage'))
      this.image = image1.data.data.image
    }
  },
  data () {
    return {
      lists: [
        { id: 1, seven: null, one: '北京清大天达光电科技股份有限公司', three: '010-87397649', four: '010-87396185', five: 'info@bjtstd.com.cn', six: '北京市平谷区马坊镇金马北街61号院2号楼1至2层101' },
        { id: 2, seven: '0351-7858553', one: '太原分公司', three: null, four: null, five: 'info@bjtstd.com.cn', six: '山西省太原市小店区学府街128号兰亭银座17层' },
      ],
      image: '',
    }
  },
  goBack () {
    if (window.history.length <= 1) {
      this.$router.push({ path: '/' })
      return false
    } else {
      this.$router.go(-1)
    }
  },
}
</script>
<style scoped>
/* 取消间隔 */
/deep/ .el-descriptions-item__label:not(.is-bordered-label) {
  margin-right: 0rem !important;
}
/* 详情的图片的大小 */

/* 标题大小 */
/deep/ .el-descriptions__title {
  width: 43.875rem !important;
  font-size: 1.875rem !important;
  color: #333333 !important;
}
/* 标题的定位：宽度长度占位 */
.el-descriptions__title {
  width: 43.875rem;
  height: 2.375rem;
  font-size: 1.875rem;
}

/* div整体和图片的距离 */
/deep/ .kong {
  margin-top: 4rem;
}
.address {
  font-weight: 600;
  color: #333333;
  font-size: 1.5rem;
}
.address_list {
  color: #666666;
  font-size: 1.25rem;
}
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
/deep/ .el-descriptions-item__label {
  font-size: 1.5rem !important;
  color: #666666;
}
/deep/ .el-descriptions-item__content {
  font-size: 1.5rem !important;
  color: #333333;
}
/deep/ .descriptions {
  width: 43.875rem !important;
  /* height: 38.75rem !important; */
  margin-left: auto !important;
  margin-right: auto !important;
}
/deep/ .img {
  width: 43.875rem !important;
  height: 18.125rem !important;
  position: relative !important;
  z-index: 1;
}
.card {
  position: absolute;
  z-index: 3;
  align-items: center;
  margin-top: 2.25rem;
}
</style>
